import { IResult } from '../types/IResponse';
import { Request } from './Request';

export interface FavoriteOrdering {
  favoriteId: string;
  favoriteIdToMoveAfter: string;
}

export interface OrderFavoritesParams {
  orderings: FavoriteOrdering[];
}

export class OrderFavoritesRequest extends Request<OrderFavoritesParams, IResult> {
  constructor(params: OrderFavoritesParams) {
    super('orderFavorites', params);
  }
}
